import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { postWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";

const ModalEditStarRezConnection = ({ onClose, starRezConnection }) => {
  const [showAlert, setIshowAlert] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [updateSettings, setSettings] = useState({
    building_name: starRezConnection ? starRezConnection.building_name : "",
    room_location_id: starRezConnection ? starRezConnection.room_location_id : "",
  });

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: type === "checkbox" ? !prevSettings[name] : value,
    }));
  };

  const saveSettings = async () => {
    try {
      setIsLoading(true);
      const response = await postWithAuth(
        API_URLS.EDIT_STARREZ_CONNECTION,
        updateSettings,
      );
      if (response.message === "success") {
        setIsLoading(false);
        window.location.reload();
      } else if (response.message === "error") {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage(response.detail);
      } else {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage("Ha ocurrido un error");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error saving StarRez connection:", error);
      setIshowAlert(true);
      setShowAlertMessage("Ha ocurrido un error");
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      saveSettings();
    } catch (error) {
      console.error("Error saving StarRez connection:", error);
    }
  };

  return (
    <Modal show={true} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edición de Building Name (StarRez)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form fv-plugins-bootstrap5 fv-plugins-framework">
          <div className="modal-body py-10 px-lg-17">
            <div className="scroll-y me-n7 pe-7">
              <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                <i className="ki-outline ki-information fs-2tx text-warning me-4"></i>
                <div className="d-flex flex-stack flex-grow-1">
                  <div className="fw-semibold">
                    <h4 className="text-gray-900 fw-bold">Atención!</h4>
                    <div className="fs-6 text-gray-700">
                      Agregar o editar esta configuración tiene consecuencias
                      importantes para el funcionamiento de la plataforma
                    </div>
                  </div>
                </div>
              </div>
              {showAlert && (
                <div className="alert alert-danger d-flex align-items-center p-5">
                  <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"></i>
                  <div className="d-flex flex-column">
                    <span className="mb-1 text-danger">{alertMessage}</span>
                  </div>
                </div>
              )}
              <div className="row g-9 mb-8">
                <div className="col-md-12 fv-row fv-plugins-icon-container">
                  <label className="required fs-6 fw-semibold mb-2">
                    Building Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    placeholder="Building Name"
                    name="building_name"
                    onChange={handleInputChange}
                    defaultValue={
                      starRezConnection ? starRezConnection.building_name : ""
                    }
                  />
                </div>
              </div>
              <div className="row g-9 mb-8">
                <div className="col-md-12 fv-row fv-plugins-icon-container">
                  <label className="fs-6 fw-semibold mb-2">
                    Room Location ID
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    placeholder="Room Location ID"
                    name="room_location_id"
                    onChange={handleInputChange}
                    defaultValue={
                      starRezConnection ? starRezConnection.room_location_id : ""
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer flex-center">
            <button
              type="reset"
              className="btn btn-light me-3"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              onClick={handleSave}
              className="btn btn-primary"
              data-kt-indicator={`${isLoading ? "on" : "off"}`}
            >
              <span className="indicator-label">Cambiar nombre</span>
              <span className="indicator-progress">
                Guardando...{" "}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalEditStarRezConnection;
